/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import ProgressBar from "../../../components/ProgressBar";

import NavigationControls from "./components/NavigationControls";
import logo from "../../../assets/mytutor-logo.svg";

export const HeaderContainer = ({ children }) => (
    <header
        css={css`
            display: flex;
            & > * {
                flex: 1;
            }
        `}
    >
        {children}
    </header>
);

const LeftColumn = ({ children }) => (
    <div
        css={css`
            flex-basis: 92px;
            padding-top: 24px;
            padding-left: 24px;
            @media (max-width: 710px) {
                display: none;
            }
        `}
    >
        {children}
    </div>
);

const CentralColumn = ({ children }) => (
    <div
        css={css`
            padding: 20px;
            flex-basis: 480px;
            max-width: 480px;
            margin: 0 auto;
        `}
    >
        {children}
    </div>
);

const RightColumn = () => (
    <div
        css={css`
            flex-basis: 92px;
            @media (max-width: 710px) {
                display: none;
            }
        `}
    />
);

const Logo = () => (
    <a href="/">
        <img
            css={css`
                width: 92px;
                height: 24px;
            `}
            src={logo}
            alt="MyTutor logo"
        />
    </a>
);

const Header = ({ title, currentStage, numberOfStages }) => (
    <HeaderContainer>
        <LeftColumn>
            <Logo />
        </LeftColumn>
        <CentralColumn>
            <NavigationControls
                title={title}
                currentStage={currentStage}
                numberOfStages={numberOfStages}
            />
            <ProgressBar
                currentStage={currentStage}
                numberOfStages={numberOfStages}
            />
        </CentralColumn>
        <RightColumn />
    </HeaderContainer>
);

export default Header;
